import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { Col, Row } from '@coursera/coursera-ui';

import { retrieveCareerPathCLPAnchorLinks } from 'bundles/browse/utils';
import { CAREER_NAME_TO_SLUG, DATA_SCIENTIST_SENIOR } from 'bundles/career-plans/constants';
import Markdown from 'bundles/cms/components/Markdown';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/career-plans';

import 'css!./__styles__/CareerPlansTimeline';

type Props = {
  roles: Array<{
    name: string;
    level: string;
  }>;
  ctaText: string;
};

class CareerPlansTimeline extends React.Component<Props, {}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof CareerPlansTimeline.contextTypes>;

  buildRole = ({ name, level }: $TSFixMe) => {
    const { router } = this.context;
    const anchorCLPLinks = (learningPathSlug: string) => retrieveCareerPathCLPAnchorLinks({ learningPathSlug });
    return (
      <div
        key={`timeline-${name}--${level}`}
        className="careerPlansTimeline-timeline--item"
        data-e2e="CareerPlansTimeline-role"
      >
        <div className="careerPlansTimeline-role">
          <TrackedA
            className="careerPlansTimeline-role--name"
            ariaLabel={`${name}-${level}`}
            href={
              name === DATA_SCIENTIST_SENIOR.DATA_SCIENTIST && level === DATA_SCIENTIST_SENIOR.SENIOR_LEVEL
                ? anchorCLPLinks('data-scientist-senior')
                : router.location.pathname.concat('#' + CAREER_NAME_TO_SLUG[name])
            }
          >
            {name}
          </TrackedA>
          {level && <div className="careerPlansTimeline-role--level">({level})</div>}
        </div>
      </div>
    );
  };

  render() {
    const { roles, ctaText } = this.props;
    if (!roles) return null;
    return (
      <Row>
        <Col className="careerPlans-container">
          <section className="rc-CareerPlansTimeline" data-e2e="CareerPlansTimeline">
            <div className="careerPlansTimeline-container">
              <div className="careerPlansTimeline-header careerPlans-sectionHeader">
                {_t('Prepare For Your Next Role')}
              </div>
              {roles.length > 0 && <div className="careerPlansTimeline-timeline">{roles.map(this.buildRole)}</div>}
            </div>
            {ctaText && (
              <div className="careerPlansTimeline-cta careerPlans-text">
                <Markdown source={ctaText} />
              </div>
            )}
          </section>
        </Col>
      </Row>
    );
  }
}

export default CareerPlansTimeline;
